
import {
    // isNull,
    // isEmpty,
    isNil,
    // forEach,
    // isArray
} from "lodash";

// import moment from 'moment';

import {kebabCase} from "@/utils/func";

const Mixin = {
    computed: {
        abbonamentoDetails(){
            if(window.TLKAbbonamentoptions.abbonamento_details)
                return window.TLKAbbonamentoptions.abbonamento_details;
            else
                return undefined;
        },
        disableUpdate(){
            if(window.TLKAbbonamentoptions.disable_update)
                return true;
            else
                return false;
            
        },
        enableUpdate(){
            return !this.disableUpdate;
        },
        isUpdate(){
            return !isNil(this.abbonamentoDetails);
        },
        GDPR_Cookie() {
            return true;
        },
        isDev() {
            return process.env.NODE_ENV !== 'production';
        },
        isProduction() {
            return process.env.NODE_ENV === 'production';
        },
        assetsPath() {
            if(window.TLKAbbonamentoptions !== "undefined"){
                return window.TLKAbbonamentoptions.assets_path;
            }else{
                return '';
            }
        }
    },
    methods: {
        log(message, ...args) {
            if (this.isDev) console.log(message, args);
        },
        GTM_trackEvent(cat,lab) {
            this.$gtm.trackEvent({
                event: "tlk_" + kebabCase(cat) + "_" + kebabCase(lab),
                action: "click",
                value: 5000,
                noninteraction: false,
            });
        },
        GTM_trackView(title,url) {
            let path = kebabCase(url);
            this.$gtm.trackView(title, path);
        },
        GTM_to_ga4( productdata ) {
            if ( !productdata ) {
                return;
            }

            const category_path  = productdata.category ? productdata.category : '';
            const category_parts = category_path.toString().split('/');

            // default, required parameters
            let ga4_product = {
                'item_id': productdata.id ? productdata.id : '',
                'item_name': productdata.name ? productdata.name : '',
                'item_brand': productdata.brand ? productdata.brand : '',
                'price': productdata.price ? productdata.price : ""
            };

            // category, also handle category path
            if ( 1 == category_parts.length ) {
                ga4_product.item_category = category_parts[0];
            } else if ( category_parts.length > 1 ) {
                ga4_product.item_category = category_parts[0];
                for( let i=1; i < Math.min( 5, category_parts.length ); i++ ) {
                    ga4_product[ 'item_category' + (i+1) ] = category_parts[i];
                }
            }

            // optional parameters which should not be included in the array if not set
            if ( productdata.variant ) {
                ga4_product.item_variant = productdata.variant;
            }
            if ( productdata.list ) {
                ga4_product.item_list_name = productdata.list;
            }
            if ( productdata.position ) {
                ga4_product.index = productdata.position;
            }
            if ( productdata.quantity ) {
                ga4_product.quantity = productdata.quantity;
            }
            if ( productdata.coupon ) {
                ga4_product.coupon = productdata.coupon;
            }

            ga4_product.google_business_vertical = window.gtm4wp_business_vertical;
            ga4_product[ window.gtm4wp_business_vertical_id ] = window.gtm4wp_id_prefix + ga4_product.item_id;

            return ga4_product;
        }

    }
};
export {
    Mixin
};